import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Entradas do link público. @fadeIn com o mesmo nome do One; @fadeInDown desce de leve, como nos apps nativos
 * (o @fadeInUp do One sobe). Curva de desaceleração do iOS e menos tempo: os 500 ms do One davam a sensação de
 * site lento. Desligadas no modo desempenho e com movimento reduzido (provideAnimationsAsync('noop'), ver
 * initialAnimationsType).
 * Curva e durações iguais às de --agj-motion-* (settings/others.scss): fadeIn em --agj-motion-base, fadeInDown em
 * --agj-motion-slow com o mesmo deslocamento da entrada em blocos (agj-reveal-down, base/motion.scss).
 * Terminam em '*' (o estilo do próprio elemento): um card com opacity .5 no CSS não pisca em 1 no fim.
 */
export const MOTION_EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [style({ opacity: 0 }), animate(`240ms ${MOTION_EASE_OUT}`, style({ opacity: '*' }))])
]);

export const fadeInDown = trigger('fadeInDown', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-14px)' }),
    animate(`380ms ${MOTION_EASE_OUT}`, style({ opacity: '*', transform: '*' }))
  ])
]);
